import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {NavigationDropdownIndicator} from "../components/NavigationDropdownIndicator";
import {NavigationUserIcon} from "../components/NavigationUserIcon";
import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {appendAmplitudeCrossDomainParams} from "../utils/append_amplitude_cross_domain_params";
import {decorateUrlWithGaLinker} from "../utils/decorate_url_with_ga_linker";
import {getFullKMLink} from "../utils/get_full_km_link";
import {getProfileGreeting} from "../utils/get_profile_greeting";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
    userName?: string | null;
    // Optional hook for the host app to decorate outgoing KM links (e.g. with cross-domain params).
    decorateKMLink?: (url: string) => string;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {kmUrl, onLogin, onLogout, isAuthenticated, isMobile, allowPopoverActivation, userName, decorateKMLink} = params;

    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();
    // For static <a href> links gtag auto-decoration (configured in init_google_tag_manager)
    // appends `_gl` on click. JS redirects below need the manual linker.
    const getKMLink = (getPath: (params: {site: SiteSlug}) => string) => {
        const url = getFullKMLink(kmUrl, getPath);

        return decorateKMLink ? decorateKMLink(url) : url;
    };

    const authenticatedUserNavigationField = {
        title: getProfileGreeting(userName),
        icon: <NavigationUserIcon />,
        dropdownIndicator: <NavigationDropdownIndicator showDropdown={!!userName} />,
        url: getKMLink(kmAppLink.site.dashboard),
        style: {
            fontWeight: 400
        },
        subElements: [
            {
                title: "Moje zapytania",
                url: getKMLink(kmAppLink.site.offers.myInquiriesWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getKMLink(kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Moje konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: onLogin,
        onHover: allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (isMobile) {
                              const kmHostname = kmUrl ? new URL(kmUrl).hostname : "";
                              window.location.href = appendAmplitudeCrossDomainParams(decorateUrlWithGaLinker(getKMLink(kmAppLink.site.dashboard)), [
                                  kmHostname
                              ]);
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {NavigationDropdownIndicator} from "../components/NavigationDropdownIndicator";
import {NavigationUserIcon} from "../components/NavigationUserIcon";
import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {appendAmplitudeCrossDomainParams} from "../utils/append_amplitude_cross_domain_params";
import {decorateUrlWithGaLinker} from "../utils/decorate_url_with_ga_linker";
import {getFullKMLink} from "../utils/get_full_km_link";
import {getProfileGreeting} from "../utils/get_profile_greeting";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
    userName?: string | null;
    // Optional hook for the host app to decorate outgoing KM links (e.g. with cross-domain params).
    decorateKMLink?: (url: string) => string;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {kmUrl, onLogin, onLogout, isAuthenticated, isMobile, allowPopoverActivation, userName, decorateKMLink} = params;

    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();
    // For static <a href> links gtag auto-decoration (configured in init_google_tag_manager)
    // appends `_gl` on click. JS redirects below need the manual linker.
    const getKMLink = (getPath: (params: {site: SiteSlug}) => string) => {
        const url = getFullKMLink(kmUrl, getPath);

        return decorateKMLink ? decorateKMLink(url) : url;
    };

    const authenticatedUserNavigationField = {
        title: getProfileGreeting(userName),
        icon: <NavigationUserIcon />,
        dropdownIndicator: <NavigationDropdownIndicator showDropdown={!!userName} />,
        url: getKMLink(kmAppLink.site.dashboard),
        style: {
            fontWeight: 400
        },
        subElements: [
            {
                title: "Moje zapytania",
                url: getKMLink(kmAppLink.site.offers.myInquiriesWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getKMLink(kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Moje konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: onLogin,
        onHover: allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (isMobile) {
                              const kmHostname = kmUrl ? new URL(kmUrl).hostname : "";
                              window.location.href = appendAmplitudeCrossDomainParams(decorateUrlWithGaLinker(getKMLink(kmAppLink.site.dashboard)), [
                                  kmHostname
                              ]);
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
